import { toLower as _toLower, startCase as _startCase } from "lodash";

export const transformItemValueToSelect = (data, value, valueKey, labelKey) => {
  const item = data.find((item) => item[valueKey] === value);

  if (!item) {
    return "";
  }

  return { label: item[labelKey], value };
};

export const transformDataToSelect = (
  data: any[],
  labelKey: string,
  valueKey: string
) => {
  if (!data || !data.length) {
    return [];
  }

  return data.map((item: any) => ({
    label: item[labelKey],
    value: item[valueKey],
  }));
};

export const transformStepsToSelect = (
  data: any[],
  labelKey: string,
  valueKey: string
) => {
  if (!data || !data.length) {
    return [];
  }

  return data.map((item: any) => ({
    label: `Szene ${item.slideOrder} - Bild ${item.order}: ${item[labelKey]}`,
    value: item[valueKey],
  }));
};

export const transformItemToSelect = (
  item: any,
  labelKey: string,
  valueKey: string
) => {
  if (!item) {
    return null;
  }

  return { label: item[labelKey], value: item[valueKey] };
};

export const transformValueToSelect = (value: any) => {
  if (!value) {
    return null;
  }

  return { label: value, value };
};

export const transformEnumToSelect = (enumData: any) =>
  Object.values(enumData).map((type: string) => ({
    label: _startCase(_toLower(type)),
    value: type,
  }));

export const getItemSelect = (data: any, value: any) => {
  const item = data.find((item) => item.value === value);

  if (!item) {
    return null;
  }

  return item;
};
